<template>
  <Modal @close="close()">
    <div
      class="delete-trip-modal-body"
      slot="body"
    >
      <div class="trash-icon-container">
        <TrashIcon
          :iconColor="'#bb5cee'"
          :width="32"
        />
      </div>
      <h1>Du er ved at slette tur</h1>
      <div>{{trip.title}}</div>
      <div class="delete-trip-modal-button-container">
        <button @click="close">Annuller</button>
        <button
          class="primary"
          @click="confirm"
        >OK</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import TrashIcon from '@/components/Icons/Trash.vue';
export default {
  name: 'delete-trip-confirmation-modal',
  components: {
    Modal,
    TrashIcon,
  },
  props: {
    trip: Object,
    confirm: Function,
    close: Function,
  },
};
</script>

<style lang="scss" scoped>
.delete-trip-modal-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
h1 {
  font-weight: 700;
  font-size: 24px;
  color: #0f1c70;
  margin: 18px 0;
}

.delete-trip-modal-button-container {
  margin: 45px 0 60px 0;
}

.trash-icon-container {
  margin-top: 20px;
  background-color: rgba(187, 92, 238, 0.145);
  height: 70px;
  width: 70px;
  border-radius: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

button {
  background-color: #adb1ce;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  padding: 0;
  font: inherit;
  cursor: pointer;
  width: 130px;
  height: 42px;
  margin: 6px;
  font-weight: 600;
  &:hover {
    box-shadow: 0 2px 10px 0 rgba(15, 28, 112, 0.251);
  }
}
.primary {
  background-color: #0f1c70;
}
</style>
